import React from 'react'
import { Col, Input, Label } from 'reactstrap'

const ImportUserTable = () => {
    return (
        <React.Fragment>
            <Col className=' mb-2'>
                <Input
                    onFocus={(e) => e.target.select()}
                    type='checkbox'
                    id='select_all'
                    name='select_all'
                />
                <Label className='mb-0 ms-1 me-2' htmlFor='select_all'> Select All</Label>
                <Input
                    onFocus={(e) => e.target.select()}
                    type="checkbox"
                    id='notify'
                    name='notify'
                />
                <Label className='mb-0 ms-1' htmlFor='notify'>Notify by Email (email inclined in login creditials)</Label>
            </Col>
            <div className="table-responsive">
                <table className="table mb-2">
                    <thead className="table-light">
                        <tr>
                            <th className="p-2 align middle sr-no-width">#</th>
                            <th className="p-2 align middle" style={{ width: '20%' }}>Name</th>
                            <th className="p-2 align middle" style={{ width: '20%' }}>Email</th>
                            <th className="p-2 align middle" style={{ width: '30%' }}>Mobile</th>
                            <th className="p-2 align middle" style={{ width: '20%' }}>Role</th>
                            <th className="p-2 align middle" style={{ width: '20%' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="p-2 align middle">
                                <Input
                                    onFocus={(e) => e.target.select()}
                                    type='checkbox'
                                    id='select_user'
                                    name='select_user'
                                />
                            </td>
                            <td className="p-2 align middle">John Doe</td>
                            <td className="p-2 align middle">+919876543210</td>
                            <td className="p-2 align middle">johndoe@gmail.com</td>
                            <td className="p-2 align middle">Group 1</td>
                            <td className="p-2 align middle">
                                <i className="bx bx-x-circle font-size-26 align-middle label-red" />
                            </td>
                        </tr>
                        <tr>
                            <td className="p-2 align middle">
                                <Input
                                    onFocus={(e) => e.target.select()}
                                    type='checkbox'
                                    id='select_user'
                                    name='select_user'
                                />
                            </td>
                            <td className="p-2 align middle">John Doe</td>
                            <td className="p-2 align middle">+919876543210</td>
                            <td className="p-2 align middle">johndoe@gmail.com</td>
                            <td className="p-2 align middle">Group 1</td>
                            <td className="p-2 align middle">
                                <i className="bx bx-check-circle font-size-26 align-middle coloured-bg-green " />
                            </td>
                        </tr>
                        <tr>
                            <td className="p-2 align middle">
                                <Input
                                    onFocus={(e) => e.target.select()}
                                    type='checkbox'
                                    id='select_user'
                                    name='select_user'
                                />
                            </td>
                            <td className="p-2 align middle">John Doe</td>
                            <td className="p-2 align middle">+919876543210</td>
                            <td className="p-2 align middle">johndoe@gmail.com</td>
                            <td className="p-2 align middle">Group 1</td>
                            <td className="p-2 align middle">
                                <i className="bx bx-error font-size-26 align-middle colour-yellow " />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    )
}

export default ImportUserTable